<template>
  <v-slide-y-transition mode="out-in">
    <v-card v-if="kompetisi">
      <v-toolbar v-bind:color="kompetisi.color" dark>
        <v-toolbar-title>{{kompetisi.name}}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn-toggle v-model="toggle_analisis" multiple>
          <v-btn flat color="error" dark>
            <v-icon>error</v-icon>
          </v-btn>
          <v-btn flat color="warning">
            <v-icon>warning</v-icon>
          </v-btn>
          <v-btn flat color="info">
            <v-icon>info</v-icon>
          </v-btn>          
        </v-btn-toggle>
      </v-toolbar>
      <v-toolbar card color="white">
        <v-text-field solo label="Type to search" v-model="tpsSearch" clearable flat hide-details >
          <v-fade-transition slot="append" leave-absolute>
            <v-progress-circular
              v-if="loading"
              size="18"
              width="2"
              :color="kompetisi.color"
              indeterminate
            ></v-progress-circular>
            <v-icon v-else :color="kompetisi.color" @click="setTps(true)">refresh</v-icon>
          </v-fade-transition>            
        </v-text-field>             
      </v-toolbar>
      <v-divider></v-divider>
      <v-progress-linear color="info" :indeterminate="true" v-if="loading" height="5" class="ma-0"></v-progress-linear>                  
      <v-card-text class="pa-0 mt-0 dapil-scroll">
        <v-list three-line class="pa-0">
          <template v-for="(item, index) in tps.data">
            <v-list-tile :key="item.id" avatar :to="{path:'/analisis/view', query:{kompetisi_id:kompetisi.id,mode:kompetisi.mode,tps_id:item.id}}">
              <v-list-tile-avatar :color="randomColor()">            
                <span class="white--text headline">{{item.no}}</span>
              </v-list-tile-avatar>
              <v-list-tile-content>
                <v-list-tile-title v-html="item.name"></v-list-tile-title>
                <v-list-tile-sub-title>
                  <v-chip color="error" text-color="white" v-if="toggle_analisis.includes(0) && terpakai(item.info)>tersedia(item.info)" small>
                    <v-avatar><v-icon>error</v-icon></v-avatar>
                    hasil {{terpakai(item.info)}} > surat suara tersedia {{(tersedia(item.info)).toFixed(0)}}
                  </v-chip>
                  <v-chip color="warning" text-color="white" v-if="toggle_analisis.includes(1)  && terpakai(item.info)>item.info.dpt" small>
                    <v-avatar><v-icon>warning</v-icon></v-avatar>
                    terpakai {{terpakai(item.info)}} > DPT {{item.info.dpt}}
                  </v-chip>
                  <v-chip color="info" v-if="toggle_analisis.includes(2)" text-color="white" small>
                    <v-avatar><v-icon>info</v-icon></v-avatar>
                    data belum lengkap
                  </v-chip>
                </v-list-tile-sub-title>                
              </v-list-tile-content>
            </v-list-tile>
            <v-divider></v-divider>
          </template>
        </v-list>
        <v-flex xs12 pa-2 pb-3 v-if="tps.data.length < tps.count">
          <v-btn block color="info" :loading="loading" small dark @click="setTps()">load more ...</v-btn>
        </v-flex>
      </v-card-text>
    </v-card>      
  </v-slide-y-transition>
</template>

<script>  
import Model  from '@/apps/frc/models/Analisis';   
import colors from 'vuetify/es5/util/colors';
const  model = new Model();
const  _  = require('lodash');


export default {    
    $_veeValidate: {
      validator: 'new'
    },    
    data: () => ({      
      active : 0,
      search : [], 
      kompetisi_id : null,
      kompetisi : null,   
      tpsSearch : null,
      tps : {data:[],count:0,page:1},
      formPath : '/kompetisi/form',      
      loading  : true,
      pagination: {},
      toggle_analisis: [0, 1, 2],
        
    }),  
    asyncComputed:{
        startKompetisi(){           
            if(this.kompetisi_id != this.$route.query.kompetisi_id){               
              this.loading = true;            
              this.kompetisi_id = this.$route.query.kompetisi_id;
              this.tps.data = [];
              return model.kompetisi({id:this.$route.query.kompetisi_id}).then(res=>{
                  let index = 0;                 
                  this.kompetisi = res.data;  
                  this.setTps(true);
              });
            } else {        
              this.tps.data = [];
              return ;//this.kompetisi;
            }
        }
    },
    watch:{
      tpsSearch(newVal){
        const ctx = this; setTimeout(function(){
          if(newVal===ctx.tpsSearch){
            ctx.setTps(true);
          }          
        },700);        
      },
      toggle_analisis(newVal){
        if(newVal.length === 0){
           this.toggle_analisis = [0,1,2];
        }
        this.setTps(true);
      }
    },
    mounted(){ },        
    created () {
        if( model.vuex ){
            var context = this;        
            context.$store.watch(
                function (state) { return state },
                function () { model.all().then(data => { context.complex.items = data }) },{ deep: true }
            );                                     
        }
    },
    methods: {      
        format(tgl) { return this.$moment(tgl).format('DD-MM-YYYY')},
                        
        terpakai(tps){
           return tps.digunakan + tps.tdk_digunakan + tps.rusak;
        },
        
        tersedia(tps){
           return tps.dpt + (tps.dpt * 0.025);
        },      
                        
        firstLetter (name) {
            return name.charAt(0);
        },
        
        persenContain(contain){
            return (contain.done/contain.all*100).toFixed(1)
        },
        
        setTps(reset = false){            
            this.loading = true;    
            if(reset) this.tps.page = 1;
            model.tps({page:this.tps.page,kompetisi_id:this.kompetisi_id,'AnalisisSearch[name]':this.tpsSearch,'AnalisisSearch[analisis]':this.toggle_analisis}).then(resp=>{
                if(reset) {this.tps.data = []; this.tps.page = 1;}                
                this.tps.data    = [...this.tps.data, ...resp.data];                
                this.tps.page++;
                this.tps.count = resp.count;   
                if(reset && this.tps.data.length === 0) {this.tps.page = 1;}
                this.loading = false;
            });
        },
        
                       
        
        formRoute(tps_id){
            let q = this.$route.query;
            this.$router.push({path:'/hitung/form', query: {
                kompetisi_id : q.kompetisi_id,
                mode : this.kompetisi.mode,
                tps_id : tps_id, 
            }});
        },
        
        hitungRoute(area_ids, tingkat_ids){
            let q = this.$route.query;
            this.$router.push({path:'/hitung', query: {
                kompetisi_id : q.kompetisi_id,
                tingkat : q.tingkat,
                area_ids : area_ids,
                tingkat_ids : tingkat_ids,                
            }});
        },
        
        urutkan(arrA, arrB){
            for(var i=0; i<arrA.length; i++){
              for(var j=i+1; j<arrA.length; j++){
                if(arrA[i]>arrA[j]){
                    var tmpA=arrA[i]; var tmpB=arrB[i]; 
                    arrA[i]=arrA[j];  arrB[i]=arrB[j];
                    arrA[j]=tmpA;     arrB[j]=tmpB;
                }     
              }   
            }
            var result = [];
            for(var i=0; i<arrA.length; i++){
              result.push({a:arrA[i], b:arrB[i]});
            }            
            return result;            
        },
        
        randomColor(){
            var randomArray   = colors;
            var color = _.sample(randomArray);     
            return color.base === undefined ? 'info':color.base;
        },
    }
}
</script>
  
